<template>
  <div v-if="show && keyInCompleted !== null">
    <el-button v-if="keyInCompleted"
               size="mini"
               type="success"
               @click="goKeyInImageGroup">
      查看KeyIn图片分组
    </el-button>
    <el-button v-else
               size="mini"
               type="primary"
               @click="goKeyInImageGroup">
      前往KeyIn图片分组
    </el-button>
  </div>
</template>

<script>

import { getExpiredTime, getLoginInfo, getToken } from '@utils/auth'

export default {
  components: {},
  props: {
    orderId: [Number, String],
    customerId: [Number, String],
  },
  data () {
    return {
      keyInTaskId: null,
      keyInCompleted: null,
      show: false,
    }
  },
  async created () {
    if (await this.isPgCustomerShow()) {
      await this.pullImageGroupStatus()
    }
  },
  methods: {
    async isPgCustomerShow () {
      const {data: {name}} = await request('getCustomerDetail', {id: this.customerId})
      if (name.includes('宝洁')) {
        this.show = true
      } else {
        this.show = false
      }
      return this.show
    },
    goKeyInImageGroup () {
      const token = getToken()
      const loginInfo = getLoginInfo(token)
      const auth = btoa(JSON.stringify({
        token: getToken(),
        guard: 'admin_api',
        expiresIn: Math.floor(getExpiredTime(loginInfo.iat, loginInfo.vt) / 1000),
        tokenType: 'bearer'
      }))
      if (this.keyInTaskId) {
        window.open(window._env_.VUE_APP_KEY_IN_DC_HOST + `/workspace/from-sj-order/${this.orderId}?taskId=${this.keyInTaskId}&auth=${auth}`, '_blank')
      } else {
        window.open(window._env_.VUE_APP_KEY_IN_DC_HOST + `/workspace/from-sj-order/${this.orderId}?auth=${auth}`, '_blank')
      }
    },
    async pullImageGroupStatus () {
      try {
        const http = axios.create({
          baseURL: window._env_.VUE_APP_KEY_IN_DC_API_HOST + '/api',
          timeout: 60000,
          headers: {
            'Accept': 'application/json',
            'Authorization-Guard': 'admin_api',
            Authorization: 'bearer ' + getToken(),
          }
        })
        const {data} = await http.get(`/tasks/from-sj-order/${this.orderId}`)
        this.keyInTaskId = data.id
        this.keyInCompleted = data.status === 5
      } catch (e) {
        console.warn(e)
        this.keyInCompleted = false
      }
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/views/order-review/components/OrderKeyInImageGroupButton.vue